import React, { useState } from 'react'
import cx from 'classnames'
import { BtnV2, l, Popover } from '@manychat/manyui'

import { useAppDispatch } from 'reduxTyped'
import { UserDisplayFlagType } from 'apps/dashboard/constants/DisplayFlagType'
import { setDisplayFlag } from 'apps/profile/actions/profileActions'
import { useDidMountEffect } from 'utils/commonHooks'

import { FusionAnalytics } from '../lib/fusionAnalytics'

import manychatIconLogo from './manychat_icon_logo_white.svg'

import '../fusionColors.css'

import * as cm from './IconToClassicWelcomeTooltip.module.css'

interface IconToClassicWelcomeTooltipProps {
  anchor: HTMLElement | null
}

// Closes only with its own button: the first click in Classic is usually navigation,
// so closing on click-away would hide the tooltip before the user reads it
export const IconToClassicWelcomeTooltip = ({ anchor }: IconToClassicWelcomeTooltipProps) => {
  const dispatch = useAppDispatch()
  // The display flag reaches the store only after the API responds, so hide the tooltip right away
  const [isClosed, setIsClosed] = useState(false)

  useDidMountEffect(() => {
    FusionAnalytics.logWelcomeTooltipShow()
  })

  const handleClose = () => {
    FusionAnalytics.logWelcomeTooltipDismiss()
    dispatch(
      setDisplayFlag({
        displayFlag: UserDisplayFlagType.SHOW_ICON_TO_CLASSIC_WELCOME_TOOLTIP,
        value: false,
      }),
    )
    setIsClosed(true)
  }

  const isOpen = !isClosed && anchor !== null

  return (
    <Popover
      open={isOpen}
      anchor={anchor}
      at="right"
      arrow
      useLayerForClickAway={false}
      theme={{ base: 'm-l-xxs', content: cm.content, arrow: cx('m-l-xxs', cm.arrow) }}
    >
      <div className={cm.body} data-test-id="icon-to-classic-welcome-tooltip">
        <img
          className={cm.logo}
          src={manychatIconLogo}
          alt={l.translate('<l10n context="Icon by Manychat is untranslatable"/>Icon by Manychat')}
        />
        <BtnV2
          onlyIcon="Close"
          size="small"
          variant="ghost-dark"
          className={cm.closeButton}
          ariaLabel={l.translate('Close')}
          onClick={handleClose}
          data-test-id="icon-to-classic-welcome-tooltip-close"
        />
        <p className={cm.text}>
          {l.translate(
            '<l10n context="Icon is untranslatable"/>Icon is one click away. Switch back from here any time.',
          )}
        </p>
      </div>
    </Popover>
  )
}
